import { matchPath } from "react-router-dom";
import { routes, type AppRoute } from "app/routes/config";

// Подставить params в шаблон пути: "/hive/:id" + {id:42} -> "/hive/42"
export const fillParams = (pattern: string, params: Record<string, string>): string => {
    return pattern.replace(/:([A-Za-z0-9_]+)/g, (_, key) => {
        const v = params[key];
        return v != null ? encodeURIComponent(String(v)) : `:${key}`;
    });
};

// Найти роут, который соответствует текущему pathname (end: true)
export const findMatchedRoute = (pathname: string) => {
    for (const r of routes) {
        const m = matchPath({ path: r.path, end: true }, pathname);
        if (m) {
            return { route: r, match: m };
        }
    }
    return null;
};

// Найти роут по parentPath (строго по path-шаблону из конфига)
export const findRouteByPathTemplate = (pathTemplate: string) => {
    return routes.find(r => r.path === pathTemplate) ?? null;
};

export type Crumb = {
    route: AppRoute;
    params: Record<string, string>;
    url: string;
    title: string;
};


export const buildBreadcrumbs = (pathname: string): Crumb[] => {
    const first = findMatchedRoute(pathname);
    if (!first) return [];

    const chain: { route: AppRoute; }[] = [];
    let cur: AppRoute | null = first.route;
    const guard = new Set<string>();

    while (cur) {
        if (guard.has(cur.path)) break;
        guard.add(cur.path);
        chain.push({ route: cur });

        const parentTemplate = cur.parentPath;
        if (!parentTemplate) break;

        const parent = findRouteByPathTemplate(parentTemplate);
        if (!parent) break;
        cur = parent;
    }


    const ordered = chain.reverse();


    const crumbs: Crumb[] = ordered.map(({ route }) => {
        const m = matchPath({ path: route.path, end: false }, pathname);
        const params = (m?.params ?? {}) as Record<string, string>;

        const matchedPathname: string | undefined = m?.pathname ?? m?.pathnameBase;
        const url = matchedPathname ?? fillParams(route.path, params);

        const title = typeof route.title === "function" ? route.title(params) : route.title;

        return { route, params, url, title };
    });

    return crumbs;
};
